import React, { useState } from 'react';
import Select from 'react-select';
import { FlagIcon } from 'react-flag-kit';
import countryData from '../../resources/countries.json';
import "../../styles/componentsStyles/ManageAccount/ProfileEdit.scss"

const ProfileEdit = () => {
    const [userDetails, setUserDetails] = useState({
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        countryCode: "",
        phone: "",
        dob: "",
        gender: ""
    });

    const countryOptions = countryData.map((country) => ({
        value: country.phone,
        label: country.name,
        flag: country.flag,
    }));

    const handlePhoneScroll = (e) => {
        e.target.blur();
    };

    // For Date Of Birth
    const today = new Date();
    const maxDate = today.toISOString().split('T')[0];

    const customOptionRenderer = (option) => (
        <div className='profile-edit__country-code-container'>
            <FlagIcon code={option.flag} />
            <span style={{ marginLeft: '10px' }}>{option.value} &nbsp;{option.label}</span>
        </div>
    );


    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "firstName") {
            // Regular expression to allow only alphabets and spaces (A-Z, a-z, and space)
            const regex = /^[A-Za-z ]+$/;
            if (regex.test(value) || value === '') {
                setUserDetails({ ...userDetails, firstName: value });
            }
        } else if (name === "lastName") {
            const regex = /^[A-Za-z]+$/;
            if (regex.test(value) || value === '') {
                setUserDetails({ ...userDetails, lastName: value });
            }
        } else if (name === "username") {
            const regex = /^[a-zA-Z0-9]+$/;

            if (regex.test(value) || value === '') {
                setUserDetails({ ...userDetails, username: value });
            }
        } else if (name === "phone") {
            const inputValue = value;
            // Check if input is numeric and has at most 10 digits
            if (/^\d{0,10}$/.test(inputValue)) {
                setUserDetails({ ...userDetails, phone: inputValue })
            }
        } else {
            setUserDetails({
                ...userDetails,
                [name]: value
            });
        }
    };

    const handleCountryCode = (countryCodeValue) => {
        setUserDetails({
            ...userDetails, countryCode: countryCodeValue
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        //  send data to server
        console.log('Form submitted successfully');
    };

    return (
        <div className='profile-edit'>
            <h2 className='profile-edit__title'>Edit Profile</h2>
            <form className='profile-edit__form' action="" onSubmit={handleSubmit}>

                <div className="profile-edit__name-container">
                    <div className="profile-edit__input-group">
                        <label htmlFor="profile-edit__first-name" className='profile-edit__label'>First Name</label>
                        <input id='profile-edit__first-name' type="text" name='firstName' placeholder='Enter your first name' autoFocus value={userDetails.firstName} onChange={handleChange} minLength={3} maxLength={60} required />
                    </div>
                    <div className="profile-edit__input-group">
                        <label htmlFor="profile-edit__last-name" className='profile-edit__label'>Last Name</label>
                        <input id='profile-edit__last-name' type="text" name="lastName" placeholder='Enter your last name' value={userDetails.lastName} onChange={handleChange} minLength={3} maxLength={30} required />
                    </div>
                </div>

                <div className="profile-edit__input-group">
                    <label htmlFor="profile-edit__username" className='profile-edit__label'>Create Username</label>
                    <input id='profile-edit__username' type="text" name="username" placeholder='Create unique username' value={userDetails.username} onChange={handleChange} minLength={7} maxLength={30} required />
                </div>

                <div className="profile-edit__input-group">
                    <label htmlFor="profile-edit__email" className='profile-edit__label'>Email</label>
                    <input id='profile-edit__email' type="email" name="email" value={userDetails.email} placeholder='Enter your email' onChange={handleChange} required />
                </div>

                <div className="profile-edit__input-group">
                    <label htmlFor="profile-edit__number" className='profile-edit__label'>Mobile No. <span>(Optional)</span></label>
                    <div className="profile-edit__phone-container">
                        <Select className='profile-edit__country-code-select'
                            name="countryCode"
                            value={userDetails.countryCode}
                            onChange={handleCountryCode}
                            options={countryOptions}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            formatOptionLabel={customOptionRenderer}
                            placeholder="country code"
                        />
                        <input id='profile-edit__number' type="text" name='phone' placeholder='Enter your mobile number' value={userDetails.phone} onWheel={handlePhoneScroll} onChange={handleChange} />
                    </div>
                </div>

                <div className="profile-edit__input-group">
                    <label htmlFor="profile-edit__dob" className='profile-edit__label'>Date of Birth <span>(Optional)</span></label>
                    <input id='profile-edit__dob' type="date" name='dob' value={userDetails.dob} max={maxDate} onChange={handleChange} />
                </div>

                <div className="profile-edit__btn-container">
                    <button className='profile-edit__button' type='submit'>Sign Up</button>
                </div>
            </form>
        </div>
    );
};

export default ProfileEdit;
